import React__default from 'react';
import { zScoreRingColors } from '../ZScore/constants.js';

var GradientDefs = function (_a) {
    var category = _a.category, _b = _a.prefixId, prefixId = _b === void 0 ? "zscore-ring" : _b;
    var colors = zScoreRingColors[category];
    return (React__default.createElement("defs", null,
        React__default.createElement("linearGradient", { id: "".concat(prefixId, "-").concat(category, "-1"), gradientTransform: "rotate(180 0.5 0.5)" },
            React__default.createElement("stop", { offset: "0.0", stopColor: colors.gradient[0] }),
            React__default.createElement("stop", { offset: "0.75", stopColor: colors.gradient[1] })),
        React__default.createElement("linearGradient", { id: "".concat(prefixId, "-").concat(category, "-2"), gradientTransform: "rotate(-36 0.5 0.5)" },
            React__default.createElement("stop", { offset: "0", stopColor: colors.gradient[1] }),
            React__default.createElement("stop", { offset: "0.75", stopColor: colors.gradient[2] }))));
};

export { GradientDefs };
